<template>
  <p class="notification is-danger has-text-centered has-text-weight-bold">
    {{ $t('banners.webhook-error') }}
  </p>
</template>

<script>
    export default {
        name: 'ErrorBanner'
    };
</script>
